//interface BillingFrequency temporaneao, da aggiornare passo passo
export enum ContractType {
  monoLight = 'Luce',
  monoGas = 'Gas',
  dual = '"Luce & Gas"',
};

export enum TitleType {
  monoLight = 'ENERGIA ELETTRICA',
  monoGas = 'GAS NATURALE',
  dual = 'ENERGIA ELETTRICA E GAS NATURALE'
};

export interface BillingFrequency {
  requestId: string;
  requestCode: string;
  requestType: ContractType;
  temporaryUrl: string;
  POD: string;
  PDR: string;
  email: string;
  fiscalCode: string;
  FirstName: string;
  LastName: string;
  phone: string;
  billingFrequency: string;
  Alg_OTPCheck__c: boolean;
  Alg_OTPCheckDate__c: string;
  Alg_OTPPhone__c:string;
  otp_verified: boolean;
};

export interface BillingFrequencyCustomerInfo {
  fiscalCode: string;
  FirstName: string;
  LastName: string;
};

export interface BillingFrequencySupplyInfo {
  POD: string;
  PDR: string;
  frequency: string;
};


// WEBPACK FOOTER //
// ./src/app/models/billingFrequency.ts